//Auto-add CSRF Token to requests
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    jqXHR.setRequestHeader('X-CSRF-Token', $('meta[name=csrf-token]').attr('content'));
});

//Refresh CSRF
// setInterval( ()=>{

//     $.ajax({
//         url : '/system/gncsrft',
//         type: "POST",
//         data : {},
//         success( token ){
//             $('meta[name="csrf_token"]').attr('content',token);

//             $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
//                 jqXHR.setRequestHeader('X-CSRF-Token', token);
//             });
//         }
//     })

// }, 600000); 

//URBO Notifications style
$.notify.addStyle('urbo', {
    html: "<div> <span data-notify-text/> </div>",
    classes: {
        base: {
            "white-space": "nowrap",
            "background-color": "#D4A35F",
            "padding": "20px",
            "font-weight" : 'bolder',
            "color": "white",
            "z-index": "99",
        },

        success : {
            "background-color": "rgba(44, 142, 75, 1);"
        },

        warning : {
            "background-color": "rgba(247, 172, 65, 1)"
        },

        error : {
            "background-color": "rgba(239, 62, 62, 1)"
        }
    }
});

$.notify.defaults({ style: "urbo" });